import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X, Mail, Clock } from 'lucide-react';
import { siteConfig } from '../config/siteConfig';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const scrollToContacts = (e) => {
    if (location.pathname === '/') {
      e.preventDefault();
      const contactsSection = document.getElementById('contacts');
      if (contactsSection) {
        contactsSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className="header">
      {/* Row 1: Top Info Bar */}
      <div className="header-top-bar">
        <div className="header-top-container">
          <a href={`tel:${siteConfig.phone}`} className="header-top-item">
            <Phone size={12} />
            <span>{siteConfig.phone}</span>
          </a>
          <a href={`mailto:${siteConfig.email}`} className="header-top-item">
            <Mail size={12} />
            <span>{siteConfig.email}</span>
          </a>
          <div className="header-top-item">
            <Clock size={12} />
            <span>{siteConfig.workingHours}</span>
          </div>
        </div>
      </div>

      {/* Row 2: Main Header */}
      <div className="header-main">
        <div className="header-main-container">
          {/* Logo */}
          <Link to="/" className="header-logo">
            <img src={siteConfig.logo} alt={siteConfig.companyName} />
          </Link>

          {/* Mobile menu button */}
          <button 
            className="mobile-menu-button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          {/* Navigation */}
          <nav className={`header-nav ${isMenuOpen ? 'mobile-open' : ''}`}>
            <Link 
              to="/" 
              className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Головна
            </Link>
            <Link 
              to="/catalog" 
              className={`nav-link ${location.pathname === '/catalog' ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Каталог
            </Link>
            <a 
              href="#contacts" 
              className="nav-link"
              onClick={(e) => {
                scrollToContacts(e);
                setIsMenuOpen(false);
              }}
            >
              Контакти
            </a>
          </nav>

          {/* Call Button */}
          <a href={`tel:${siteConfig.phone}`} className="header-cta-button">
            <Phone size={18} />
            <span>Зателефонувати</span>
          </a>
        </div>
      </div>
    </header>
  );
};
